import { IRule } from "../../../../../interfaces/rule";
import UtilsService from "../../../../../services/utils.service";

interface RuleCardProps {
  rule: IRule;
  showBlockName?: boolean;
}

export default function RuleCard(props: RuleCardProps): JSX.Element {
  const { rule, showBlockName } = props;
  const { getColorFromPercentage } = UtilsService();

  const porcentaje = Math.round((rule.total_correct / (rule.total_correct + rule.total_incorrect)) * 100);
  const questionsPerTest = parseFloat(
      ((rule.questions.total * 100) / rule.tests.total).toFixed(2)
    );
  const color = getColorFromPercentage(porcentaje);

  return (
    <div className="border-solid border-2 border-primary-200 rounded-lg shadow-md px-8 py-6 flex justify-center transform transition-transform duration-300 ease-in-out hover:scale-105">
      <div className="w-[70%] flex flex-col">
        <h1 className="text-4xl font-bold">{rule.name}</h1>
        <p>
          <b>Nivel: </b>{rule.average_difficulty}
        </p>
      </div>

      <div className="w-[35%] flex flex-col justify-end pr-4">
          <div className="grid grid-cols-2 gap-y-1 w-full justify-items-end">
              <p className="col-span-2 float-right">Preguntas totales: {rule.questions.total}</p>
              <p className="col-span-2 float-right">Reportes totales: {rule.reports.total}</p>
              <p className="col-span-2 float-right">Test totales: {rule.tests.total}</p>
              <p className="col-span-2 float-right">Relación preguntas/test: {questionsPerTest}%</p>
              {showBlockName && (
                <p className="col-span-2 float-right">Bloque: {rule.block_name}</p>
              )}
              <p className="col-span-2 text-5xl font-bold" style={{ color }}>
              {porcentaje}%
              </p>
          </div>
      </div>
    </div>
  );
}
